import { render, staticRenderFns } from "./DashboardSupportCard.vue?vue&type=template&id=01b08fbe&scoped=true&"
import script from "./DashboardSupportCard.vue?vue&type=script&lang=js&"
export * from "./DashboardSupportCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSupportCard.vue?vue&type=style&index=0&id=01b08fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b08fbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
